import React, {useState} from "react";
import PropTypes from "prop-types";

const TailwindFloatingInput = ({
	label,
	type = "text",
	value = "",
	error = false,
	errorText = "",
	placeholder,
	onChange,
	onEnter,
	rightSlot,
}) => {
	const [isFocused, setIsFocused] = useState(false);
	const isActive = isFocused || value.trim().length > 0;

	const borderClass = error
		? "border-[#C94545]"
		: isActive
			? "border-[#3DBA71]"
			: "border-[#A3AEC4]";

	const labelClass = error ? "text-[#C94545]" : "text-[#3DBA71]";

	return (
		<div>
			<div className={`relative h-14 rounded-[14px] border px-4 ${borderClass}`}>
				{isActive ? (
					<span className={`absolute -top-[11px] left-4 bg-white px-2 text-base leading-none ${labelClass}`}>
						{label}
					</span>
				) : null}
				<div className="flex h-full items-center">
					<input
						type={type}
						value={value}
						onChange={(e) => onChange(e.target.value)}
						onFocus={() => setIsFocused(true)}
						onBlur={() => setIsFocused(false)}
						onKeyDown={(e) => {
							if (e.key === "Enter" && onEnter) onEnter();
						}}
						className={`h-full w-full border-0 bg-transparent text-base text-[#1E1F21] outline-none ${
							rightSlot ? "pr-3" : ""
						}`}
						placeholder={isActive ? "" : (placeholder || label)}
					/>
					{rightSlot ? <div className="ml-2 flex items-center">{rightSlot}</div> : null}
				</div>
			</div>
			{error && errorText ? <p className="mt-2 text-sm text-[#C94545]">{errorText}</p> : null}
		</div>
	);
};

TailwindFloatingInput.propTypes = {
	label: PropTypes.string.isRequired,
	type: PropTypes.string,
	value: PropTypes.string,
	error: PropTypes.bool,
	errorText: PropTypes.string,
	placeholder: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onEnter: PropTypes.func,
	rightSlot: PropTypes.node,
};

export default TailwindFloatingInput;
